export default "__VITE_ASSET__d86c675f__"